<template>
  <a-layout class="app-sub">
    <Header v-if="isConfiguredRoute" />
    <BackHeader v-if="!isConfiguredRoute && !loading && !notShowHeader" />
    <a-layout>
      <a-layout-sider
        v-if="isConfiguredRoute"
        class="main-content-sider"
      >
        <div
          class="d-flex"
          style="height: 100%"
        >
          <div class="sider-left">
            <img
              class="logo"
              src="https://hh-oss-picture.miyapay.com/box/8ba0cb0fa7bc7ae75ef1eb1addf62d55.png"
              width="48"
              height="48"
            >
            <template v-for="route in authRoutesConfig">
              <div
                :pro="route.authId"
                :key="route.path"
                class="menu-item"
                :class="{ active: route.path === selectedMenu.path }"
                @click="updateMenu(route.path)"
              >
                <BizIcon
                  v-if="route.icon"
                  :type="route.icon"
                  style="margin-right: 5px"
                />
                {{ route.name }}
              </div>
            </template>
          </div>
          <div class="sider-right">
            <div class="d-flex align-center route-name">
              {{ selectedMenu.name }}
            </div>
            <div class="route-menu">
              <sider-menu :routes="currentRoutes" />
            </div>
          </div>
        </div>
      </a-layout-sider>
      <a-layout-content class="main-content">
        <div id="subapp-root" />
        <router-view />
      </a-layout-content>
      <aside>
        <Loading :loading="loading" />
      </aside>
    </a-layout>
  </a-layout>
</template>

<script>
import localforage from "localforage";
import { loadMicroApp } from "qiankun";
import { noop } from "lodash";
// import store from '@/store';
import { getAppByPath, isUnderSameMicroApp } from "@/micro-apps";
import Header from "@/components/Header";
import BackHeader from "@/components/BackHeader";
import SiderMenu from "@/components/SiderMenu";
import Loading from "@/components/loading";
import { getRouteByPath, goToFirstValidRoute } from "@/utils/helpers";
import { AUTH_ROUTES_CONFIG } from "@/consts";
import BizIcon from "@/components/BizIcon";
import { mapState } from "vuex";

// function hasMatchedProduct(toPath) {
//   const { appProductIdList } = store.state.user.userInfo;
//   const activeApp = getAppByPath(toPath);

//   if (activeApp && appProductIdList.includes(activeApp.meta.productId)) {
//     return true;
//   }

//   return false;
// }

export default {
  components: {
    Header,
    BackHeader,
    SiderMenu,
    Loading,
    BizIcon
  },
  data() {
    return {
      microApp: null,
      loadingMicroApp: null,
      loading: false,
      authRoutesConfig: [],
      selectedMenu: {},
      openKeys: []
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    phone() {
      return (this.userInfo || {}).phone;
    },
    merchant() {
      return (this.userInfo || {}).merchant;
    },
    currentRoutes() {
      return (
        (
          this.authRoutesConfig.find(m => m.path === this.selectedMenu.path) || {}
        ).routes || []
      );
    },
    flatRoutes() {
      const routes = [];

      const loop = routesToLoop => {
        routesToLoop.forEach(r => {
          routes.push(r.path);
          if (r.routes && r.routes.length > 0) {
            loop(r.routes);
          }
        });
      };

      loop(this.authRoutesConfig);

      return routes;
    },
    isConfiguredRoute() {
      // 没有配置在routesconfig的路由不需要显示header和左侧sidermenu
      return this.flatRoutes.includes(this.$route.path);
    },
    // isNoneBack() {
    //   return this.$route.path === '/intelligent-marketing/marketing/marketing-manage/activity/creator';
    // },
    notShowHeader() {
      return this.$route.path.indexOf('/retail') !== -1;
      /* return this.$route.path === '/retail/customer-page/edit'; */
    }
  },
  async mounted() {
    this.setMenu();
    this.loadingMicroApp = this.loadApp(this.$route);
    console.log('this.$route.path===>', this.$route.path);
  },
  watch: {
    "$route.path": function(){// eslint-disable-line
      this.setMenu();
    }
  },
  methods: {
    updateMenu(path) {
      // 修改header大菜单后显示该大菜单下的第一个路由
      goToFirstValidRoute(this.$router, path);
    },
    async setMenu() {
      this.authRoutesConfig = await localforage.getItem(AUTH_ROUTES_CONFIG);

      const currentRoute = getRouteByPath(
        this.$route.path,
        this.authRoutesConfig
      );
      const { parents } = currentRoute || {};
      if (parents && parents[0]) {
        [this.selectedMenu] = parents;
      }
    },
    loadApp(to) {
      this.loading = true;
      return new Promise(resolve => {
        const { path } = to;
        const app = getAppByPath(path);

        if (!app) {
          this.loading = false;
          resolve();
        } else {
          const microApp = loadMicroApp(app, {
            excludeAssetFilter: (assetUrl) => {
                // 定义一个白名单，包含需要排除的关键字
                const whiteWords = [
                  'map.qq.com', // 排除腾讯地图API
                ];
                // 如果资源URL包含白名单中的任意一个关键字，则返回true，使其不被qiankun处理
                return whiteWords.some(word => assetUrl.includes(word));
              },
          });
          this.microApp = microApp;
          microApp.loadPromise.catch(() => {
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }).then(() => {
            this.loading = false;
          });
          resolve(microApp);
        }
      });
    },
    unmountApp() {
      return new Promise(resolve => {
        const { microApp } = this;

        if (!microApp) {
          resolve();
        } else {
          const status = microApp.getStatus();

          if (status !== "MOUNTED") {
            if (status === "UNMOUNTING") {
              resolve(microApp.unmountPromise.catch(noop));
            } else {
              resolve(
                Promise.all([
                  microApp.loadPromise,
                  microApp.bootstrapPromise,
                  microApp.mountPromise
                ]).then(() => microApp.unmount()).catch(noop)
              );
            }
          } else {
            resolve(microApp.unmount());
          }
        }
      });
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   userSetupPromise.then(() => {
  //     const {
  //       initiated,
  //       userInfo,
  //     } = store.state.user;
  //     debugger;
  //     if (initiated) {
  //       const { appProductIdList } = userInfo;

  //       if (appProductIdList.length > 0) {
  //         if (hasMatchedProduct(to.path)) {
  //           next();
  //         } else {
  //           // get configured first product's app
  //           const app = getAppByProductId(appProductIdList[0]);

  //           if (app) {
  //             next(app.activeRule);
  //           } else {
  //             next(PATH_LOGIN);
  //           }
  //         }
  //       } else {
  //         store.commit('reportError', new Error('该账号没有配置已支持的产品'));
  //         next(PATH_LOGIN);
  //       }
  //     } else {
  //       next(PATH_LOGIN);
  //     }
  //   });
  // },
  async beforeRouteUpdate(to, from, next) {
    const app = getAppByPath(to.path);
    const targetIsMicroApp = app != null;

    if (targetIsMicroApp) {
      if (isUnderSameMicroApp(to.path, from.path)) {
        next();
        return;
      }

      await this.unmountApp();
      await this.loadApp(to);
      setTimeout(() => {
        next();
      }, 0);

      return;
    }

    this.unmountApp().then(() => {
      next();
    });
  }
};
</script>
<style lang="scss" scoped>
.app-sub {
  height: 100%;
}
.main-content {
  height: calc(100vh - 64px);
  overflow-y: auto;
}

.main-content-sider {
  overflow-x: hidden;
  margin-top: -64px;
  height: 100vh;
  flex: 0 0 252px !important;
  max-width: 252px !important;
  min-width: 252px !important;
  width: 252px !important;
}

.logo {
  height: 48px;
  width: 48px;
  margin: 16px 36px;
}

.sider-left {
  flex: 0 0 120px;
  width: 120px;
  background: #182035;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.sider-right {
  flex: 0 0 132px;
  width: 132px;
  height: 100vh;
  overflow-x: hidden;

  .route-name {
    height: 64px;
    padding-left: 24px;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #e8e8e8;
  }

  .route-menu {
    border-right: 1px solid #e8e8e8;
    height: calc(100vh - 64px);
    overflow-y: auto;
  }
}

.menu-item {
  height: 48px;
  line-height: 48px;
  width: 120px;
  background: #182035;
  color: #fff;
  cursor: pointer;
  padding-left: 18px;

  &.active {
    background: #fff;
    color: #182035;
    border-left: 3px solid var(--main-color);
  }
}
</style>
<style>
body, html {
  height: 100%;
}
</style>
